///////////////////////////////////////////////////////////////////////////////
//
//  AutobahnJS - http://autobahn.ws, http://wamp.ws
//
//  A JavaScript library for WAMP ("The Web Application Messaging Protocol").
//
//  Copyright (C) 2011-2014 Tavendo GmbH, http://tavendo.com
//
//  Licensed under the MIT License.
//  http://www.opensource.org/licenses/mit-license.php
//
///////////////////////////////////////////////////////////////////////////////

/* eslint spaced-comment:0,vars-on-top:0,no-var:0,camelcase:0,func-names:0,one-var:0,one-var-declaration-per-line:0,eqeqeq:0,
no-multiple-empty-lines:0,prefer-rest-params:0,block-scoped-var:0,no-use-before-define:0,prefer-template:0,no-restricted-syntax:0,
no-debugger:0,padded-blocks:0,no-else-return:0,quotes:0,object-curly-spacing:0,semi:0,space-infix-ops:0,no-console:0 */
/* global AUTOBAHN_DEBUG:true */

if (typeof window === 'object' && window !== null) {
    window.Promise = window.Promise || require('es6-promise-polyfill').Promise;
}
var util = require('./util.js');
var session = require('./session.js');
var connection = require('./connection.js');
var configure = require('./configure.js');
var serializer = require('./serializer.js');


exports.transports = configure.transports;

exports.Connection = connection.Connection;

exports.Session = session.Session;
exports.Invocation = session.Invocation;
exports.Event = session.Event;
exports.Result = session.Result;
exports.Error = session.Error;
exports.Subscription = session.Subscription;
exports.Registration = session.Registration;
exports.Publication = session.Publication;

exports.serializer = serializer;


exports.util = util;



// WEBPACK FOOTER //
// ./src/lightweight-autobahn/src/autobahn.js